const rawBaseUrl = process.env.REACT_APP_API_URL_SGE;

if (!rawBaseUrl) {
  throw new Error("❌REACT_APP_API_URL is not set. Please define it in your .env file.");
}

const baseUrl = rawBaseUrl.endsWith("/") ? rawBaseUrl.slice(0, -1) : rawBaseUrl;
const apiUrl = baseUrl.endsWith("/api") ? baseUrl : `${baseUrl}/api`;


export default apiUrl;






